import {Action} from '@ngrx/store';
import {IEmployee, ISyncStatus} from '@signal/asp-data-commons';

export enum EmployeeActionTypes {
  LOAD_EMPLOYEES = '[Employee] Load employees',
  LOAD_EMPLOYEES_SUCCESS = '[Employee] Load employees success',
  LOAD_EMPLOYEES_FAILURE = '[Employee] Load employees failure',
  LOAD_EMPLOYEE = '[Employee] Load employee',
  LOAD_EMPLOYEE_SUCCESS = '[Employee] Load employee success',
  LOAD_EMPLOYEE_FAILURE = '[Employee] Load employee failure',
  UPDATE_EMPLOYEE = '[Employee] Update employee',
  UPDATE_EMPLOYEE_SUCCESS = '[Employee] Update employee success',
  UPDATE_EMPLOYEE_FAILURE = '[Employee] Update employee failure',
  UPDATE_TEAM_DETAILS = '[Team page] Update employee team details',
  UPDATE_TEAM_DETAILS_SUCCESS = '[Employee API] Update employee team details success',
  UPDATE_TEAM_DETAILS_FAILURE = '[Employee API] Update employee team details failure',
  LOAD_STAFF_MASTER_SYNC_STATUS = '[Employee] Load staff master employee sync status',
  LOAD_STAFF_MASTER_SYNC_STATUS_SUCCESS = '[Employee API] Load staff master employee sync status success',
  LOAD_STAFF_MASTER_SYNC_STATUS_FAILURE = '[Employee API] Load staff master employee sync status fail',
  TRIGGER_STAFF_MASTER_SYNC = '[Employee] Trigger staff master employee sync',
  TRIGGER_STAFF_MASTER_SYNC_SUCCESS = '[Employee API] Trigger staff master employee sync success',
  TRIGGER_STAFF_MASTER_SYNC_FAILURE = '[Employee API] Trigger staff master employee sync fail',
  LOAD_PRESIGNED_URL = '[Employee API] Load Presigned url',
  LOAD_PRESIGNED_URL_SUCCESS = '[Employee API] Load Presigned url success',
  LOAD_PRESIGNED_URL_FAIL = '[Employee API] Load Presigned url fail',
}

export class LoadEmployees implements Action {
  readonly type: string = EmployeeActionTypes.LOAD_EMPLOYEES;

  constructor() {
  }
}

export class LoadEmployeesSuccess implements Action {
  readonly type = EmployeeActionTypes.LOAD_EMPLOYEES_SUCCESS;

  constructor(public payload: { employees: IEmployee[] }) {
  }
}

export class LoadEmployeesFail implements Action {
  readonly type = EmployeeActionTypes.LOAD_EMPLOYEES_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadEmployee implements Action {
  readonly type: string = EmployeeActionTypes.LOAD_EMPLOYEE;

  constructor(public payload: { employeeId: string }) {
  }
}

export class LoadEmployeeSuccess implements Action {
  readonly type = EmployeeActionTypes.LOAD_EMPLOYEE_SUCCESS;

  constructor(public payload: { employee: IEmployee }) {
  }
}

export class LoadEmployeeFail implements Action {
  readonly type = EmployeeActionTypes.LOAD_EMPLOYEE_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class UpdateEmployee implements Action {
  readonly type = EmployeeActionTypes.UPDATE_EMPLOYEE;

  constructor(public payload: { employee: IEmployee, isLoadNotificationData?: boolean}) {
  }
}

export class UpdateEmployeeSuccess implements Action {
  readonly type = EmployeeActionTypes.UPDATE_EMPLOYEE_SUCCESS;

  constructor(public payload: { employee: IEmployee}) {
  }
}

export class UpdateEmployeeFail implements Action {
  readonly type = EmployeeActionTypes.UPDATE_EMPLOYEE_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class UpdateTeamDetails implements Action {
  readonly type = EmployeeActionTypes.UPDATE_TEAM_DETAILS;

  constructor(public payload: { employees: IEmployee[] }) {
  }
}

export class UpdateTeamDetailsSuccess implements Action {
  readonly type = EmployeeActionTypes.UPDATE_TEAM_DETAILS_SUCCESS;

  constructor(public payload: IEmployee) {
  }
}

export class UpdateTeamDetailsFail implements Action {
  readonly type = EmployeeActionTypes.UPDATE_TEAM_DETAILS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadStaffMasterSyncStatus implements Action {
  readonly type = EmployeeActionTypes.LOAD_STAFF_MASTER_SYNC_STATUS;

  constructor() {}
}

export class LoadStaffMasterSyncStatusSuccess implements Action {
  readonly type = EmployeeActionTypes.LOAD_STAFF_MASTER_SYNC_STATUS_SUCCESS;

  constructor(public payload: {syncStatus: ISyncStatus}) {
  }
}

export class LoadStaffMasterSyncStatusFail implements Action {
  readonly type = EmployeeActionTypes.LOAD_STAFF_MASTER_SYNC_STATUS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class TriggerStaffMasterSync implements Action {
  readonly type = EmployeeActionTypes.TRIGGER_STAFF_MASTER_SYNC;

  constructor() {}
}

export class TriggerStaffMasterSyncSuccess implements Action {
  readonly type = EmployeeActionTypes.TRIGGER_STAFF_MASTER_SYNC_SUCCESS;

  constructor(public payload: {syncStatus: ISyncStatus}) {
  }
}

export class TriggerStaffMasterSyncFail implements Action {
  readonly type = EmployeeActionTypes.TRIGGER_STAFF_MASTER_SYNC_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadPreSignedUrl implements Action {
  readonly type: string = EmployeeActionTypes.LOAD_PRESIGNED_URL;

  constructor(public payload:{empId:string,imageFormat:string}) {
  }
}

export class LoadPreSignedUrlSuccess implements Action {
  readonly type: string = EmployeeActionTypes.LOAD_PRESIGNED_URL_SUCCESS;

  constructor(public payload:{data:string}) {
  }
}

export class LoadPreSignedUrlFail implements Action {
  readonly type: string = EmployeeActionTypes.LOAD_PRESIGNED_URL_FAIL;

  constructor(public payload: { error: string }) {
  }
}


export type EmployeeActions =
  | LoadEmployees
  | LoadEmployeesSuccess
  | LoadEmployeesFail
  | LoadEmployee
  | LoadEmployeeSuccess
  | LoadEmployeeFail
  | UpdateEmployee
  | UpdateEmployeeSuccess
  | UpdateEmployeeFail
  | UpdateTeamDetails
  | UpdateTeamDetailsSuccess
  | UpdateTeamDetailsFail
  | LoadStaffMasterSyncStatus
  | LoadStaffMasterSyncStatusSuccess
  | LoadStaffMasterSyncStatusFail
  | TriggerStaffMasterSync
  | TriggerStaffMasterSyncSuccess
  | TriggerStaffMasterSyncFail
  ;
